







































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import IUser from '@/models/IUser'
import AccountList from '@/components/AccountList.vue'
import accountService from '@/services/AccountService'

@Component({
  components: {
    'account-list': AccountList,
    'app-resume': () => import('@/components/AppResume.vue'),
    'fab-button': () => import('@/components/FabButton.vue')
  }
})
export default class Home extends Vue {
  @Getter
  public user!: IUser | null
  public showAccounts: boolean = false

  public async created() {
    const accounts = await accountService.getAll()
    this.showAccounts = !!accounts.length
  }
}
